<template>
  <keep-alive v-if="!!parameterComponent">
    <component :is="parameterComponent" :disabled="disabled" />
  </keep-alive>
  <div v-else>atopic dermatitis parameter not found</div>
</template>

<script>
import { PropsDefinition } from '@/_typedefs'
import ScoradParameterNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/ScoradParameterNode.vue'
import EasiBsaParameterNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/EasiBsaParameterNode.vue'
import IgaParameterNode from '@/components/NewAttendanceForm/AtopicDermatitis/Parameters/IgaParameterNode.vue'

/**
 * @typedef {Object} AtopicDermatitisParameterNodeProps
 * @property {string} kind
 */

export default {
  name: 'AtopicDermatitisParameterNode',
  /** @type {PropsDefinition<AtopicDermatitisParameterNodeProps>} */
  props: {
    kind: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** @type {Computed<Component?>} */
    parameterComponent() {
      const parameterMap = {
        'atopic-dermatitis:scorad': ScoradParameterNode,
        'atopic-dermatitis:easi-bsa': EasiBsaParameterNode,
        'atopic-dermatitis:iga': IgaParameterNode,
      }

      return parameterMap[this.kind] ?? null
    },
  },
}
</script>

<style></style>
